export class DbQueries {
  public static USER_ROLE_INSERT = `INSERT OR REPLACE INTO
        user_role (user_id, user_role, tenant_id, qbos_user_id)
        VALUES (?, ?, ?, ?)
    `;

  public static TEAM_ROLE_INSERT = `INSERT OR REPLACE INTO team_role
        (tenant_id, team_role, role_lookup_code, work_group) VALUES (?, ?, ?, ?)`;

  public static LOOKUP_INSERT = `INSERT OR REPLACE INTO lookup
        (tenant_id, lookup_code, lookup_type_code, lookup_value, lookup_value1, description,
            sort_sequence, is_default_visible, lookup_reference_key)
        VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?)`;

  public static ASSESSMENT_TYPE_COUNT = `SELECT count(*) AS asmtTypeCount FROM assessment_type
        WHERE assessment_type_lookup_code = ? AND level_of_care_lookup_code = ? AND role_lookup_code = ?`;

  public static ASSESSMENT_TYPE_INSERT = `INSERT OR REPLACE INTO assessment_type
        (tenant_id, assessment_type_lookup_code, level_of_care_lookup_code, role_lookup_code)
        VALUES (?, ?, ?, ?)`;

  public static ASSESSMENT_CLEAR = `DELETE FROM assessments`;

  public static DELETE_ASSESSMENT_BY_ASMT_ID = `DELETE FROM assessments WHERE id=?`;

  public static ASSESSMENT_INSERT = `INSERT OR REPLACE INTO assessments
        (id, uuid, pat_chart_id, addendum, asmt_status_lookup_code,
        asmt_status_lookup_value, asmt_type_lookup_code, asmt_type_lookup_value, care_plan_status_lookup_code, care_plan_status_lookup_value,
        coordinationOfCareAddendum, duration, end_dte, performed_by, performed_by_id,
        role_lookup_code, role_lookup_value, started_dte, timezone, created_date, completed_date, offline_insert)
        VALUES 
        (?, ?, ?, ?, ?,
        ?, ?, ?, ?, ?,
        ?, ?, ?, ?, ?,
        ?, ?, ?, ?, ?,
        ?, ?)`;

  public static SELECT_PREVIOUS_ASSESSMENT_ID_BY_ROLE_LOOKUP = `SELECT id as asmt_id FROM assessments 
        WHERE asmt_status_lookup_value = "Completed" AND pat_chart_id = ? AND completed_date < ? AND role_lookup_code = ?
        ORDER BY completed_date DESC LIMIT 1`;

  public static SELECT_HISTORY_ASSESSMENT_IDS = `SELECT id as asmt_id FROM assessments 
        WHERE asmt_status_lookup_value = "Completed" AND pat_chart_id = ? AND completed_date < ? 
        ORDER BY completed_date DESC`;

  public static SELECT_ASSESSMENT_MAX_ID = `select max(assessment_id) as assessment_id from offline_actions`;
  public static SELECT_ASSESSMENT_TEMPLATE_MAX_ID = `select max(id) as asmt_tmpl_id from assessment_template`;

  public static ASSESSMENT_SELECT_BY_PATIENT = `SELECT * FROM assessments WHERE pat_chart_id=? ORDER BY id DESC`;

  public static ASSESSMENT_SELECT_BY_ID = `SELECT * FROM assessments WHERE id=?`;

  public static ASSESSMENT_UPDATE_BY_ID = `UPDATE assessments SET id=? WHERE id=?`;

  public static OFFLINE_ACTION_INSERT = `INSERT INTO offline_actions
        (assessment_id, action, visit_type, payload, patient_id,
        patient_name, expire_at, updated_at, asmt_type_lookup_code, role_lookup_code)
        VALUES
        (?, ?, ?, ?, ?,
        ?, ?, ?, ?, ?)`;

  public static OFFLINE_ACTION_DELETE = `DELETE FROM offline_actions WHERE action_id=?`;

  public static OFFLINE_ACTION_SELECT_ALL = `SELECT * FROM offline_actions ORDER BY updated_at`;

  public static OFFLINE_ACTION_SELECT_ALL_COUNT = `SELECT count(action_id) as totalActions FROM offline_actions`;

  public static OFFLINE_ACTION_SELECT_BY_ASMT = `SELECT * FROM offline_actions WHERE assessment_id=?`;

  public static OFFLINE_ACTION_SELECT_BY_ACTION_ID = `SELECT * FROM offline_actions WHERE action_id=?`;

  public static OFFLINE_ACTION_UPDATE = `UPDATE offline_actions SET payload=?, expire_at=?, updated_at=? WHERE assessment_id=?`;

  public static GET_ASMT_PATIENT_AND_TYPE = `SELECT 
        a.pat_chart_id, a.asmt_type_lookup_value, p.patientFullName 
        FROM assessments a
        INNER JOIN patient_data p 
        ON a.pat_chart_id = p.chartid 
        WHERE a.id = ?`;

  public static ASSESSMENT_TEMPLATE_UPDATE_BY_ASMT_ID = `UPDATE assessment_template SET assessment_id=? WHERE assessment_id=?`;

  public static ASSESSMENT_TEMPLATE_CLEAR = `DELETE FROM assessment_template`;

  public static DELETE_ASSESSMENT_TEMPLATE_BY_ASMT_ID = `DELETE FROM assessment_template WHERE assessment_id=?`;

  public static ASSESSMENT_TEMPLATE_INSERT = `INSERT INTO assessment_template
        (id, uuid, tenant_id, pat_chart_id, assessment_id,
        rec_type_lookup_code, tmpl_json, created_by, created_date, updated_by,
        updated_date, version, active_flag)
        VALUES 
        (?, ?, ?, ?, ?,
        ?, ?, ?, ?, ?,
        ?, ?, ?)`;

  public static ASSESSMENT_TEMPLATE_SELECT_BY_ASMT_ID_AND_SECTION = `SELECT * 
        FROM assessment_template 
        WHERE assessment_id=? AND rec_type_lookup_code=?`;

  public static TEMPLATE_REPLACEMENT_DATA_INSERT: string = `INSERT OR REPLACE INTO template_replacement_data
        (patient_id, family_contacts, lpn_contacts, hha_contacts, physician_contacts) 
        VALUES 
        (?, ?, ?, ?, ?)`;

  public static TEMPLATE_REPLACEMENT_DATA_SELECT: string = `SELECT * FROM template_replacement_data WHERE patient_id=?`;

  public static STATIC_DATA_INSERT: string = `INSERT OR REPLACE INTO static_data (api_path, api_response) VALUES (?,?)`;

  public static STATIC_DATA_SELECT: string = `SELECT * FROM static_data WHERE api_path=?`;

  public static SELECT_TEAM_ROLE = `select * from team_role`;
  public static SELECT_ASSESSMENT_TYPE = `select
        l.sort_sequence as sort_seq,
        a.assessment_type_lookup_code as asmt_type_lookup_code,
        l.lookup_value as asmt_type_lookup_value
        from lookup l
        LEFT JOIN assessment_type a ON a.assessment_type_lookup_code = l.lookup_code
        where a.role_lookup_code = ? and a.level_of_care_lookup_code = ?
        group by l.lookup_code
        order by l.sort_sequence;
    `;

  public static PATIENT_CLEAR = `DELETE FROM patient_data`;

  public static DELETE_PATIENT_BY_CHART_ID = `DELETE FROM patient_data WHERE chartId = ?`;

  public static PATIENT_COUNT = `SELECT count(*) AS patientCount FROM patient_data WHERE chart_id = ?`;

  public static PATIENT_INSERT = `INSERT OR REPLACE INTO patient_data 
        (chartId, userId, patientFullName, dateOfBirth, age,
        primaryDiagnosis, secondaryDiagnosis, levelOfCare, codeStatus, careTeam, 
        caseManagerFullName, certifyingPhysicianFullame, nursePractitioner, attendingPhysicianFullName, medicalDirectorFullName,
        careLocationType, careLocationAddress1, careLocationCity, careLocationState,
         careLocationZip, primaryCareGiverFullName, primaryCareGiverPhoneNumber, riskPriority,patientGender,benefitPeriod,
        foodAllergies, drugAllergies, dareStatus )
        VALUES 
        (?,?,?,?,?,?,
         ?,?,?,?,?,
         ?,?,?,?,?,
         ?,?,?,?,?,
         ?,?,?,?,?,?,
         ?)`;

  public static UNPLANNED_PATIENT_INSERT = `INSERT OR REPLACE INTO patient_data 
        (chartId, userId, patientFullName, levelOfCare, patientGender)
        VALUES
        (?, ?, ?, ?, ?)
    `;

  public static SELECT_PATIENT_DATA: string = `SELECT * FROM patient_data WHERE userId=?`;

  public static PROFILE_SELECT_BY_PATIENT = `SELECT * FROM patient_data WHERE chartId=?`;
  public static IS_USER_ROLE_EXISTS = `SELECT * FROM user_role WHERE user_id = ?`;

  public static DELETE_USER_ROLE: string = `DELETE FROM user_role`;
  public static DELETE_TEAM_ROLE: string = `DELETE FROM team_role`;
  public static DELETE_LOOKUP: string = `DELETE FROM lookup`;
  public static DELETE_ASSESSMENT_TYPE: string = `DELETE FROM assessment_type`;

  public static INSERT_LEVEL_OF_CARE = `INSERT OR REPLACE INTO level_of_care
        (level_of_care_lookup_code, level_of_care_code, level_of_care_value)
        VALUES
        ('SD001.1', 'Routine', 'Routine Home Care'),
        ('SD001.2', 'GIP', 'General In-Patient'),
        ('SD001.3', 'Continuous', 'Continuous Care'),
        ('SD001.4', 'Respite', 'Respite Care'),
        ('SD001.5', 'Palliative', 'Palliative')
    `;

  public static SELECT_LEVEL_OF_CARE: string = `
        select lc.level_of_care_lookup_code
        from level_of_care lc
        left join patient_data pd
        on lc.level_of_care_value = pd.levelOfCare
        where pd.chartId = ?;
    `;

  public static SELECT_All_LEVEL_OF_CARE: string = `select * from level_of_care where level_of_care_lookup_code != "SD001.5"`;

  public static INSERT_ASSESSMENT_DETAILS: string = `
        INSERT OR REPLACE INTO assessment_details
        (id, uuid, tenant_id, assessment_id, pat_chart_id, assessment_detail_id, status_lookup_code, section_type_lookup_code,
            rec_type_lookup_code, data_json, level, created_by, created_date, updated_by, updated_date,
            version, active_flag)
        VALUES(?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
    `;

  public static DELETE_ASSESSMENT_DETAILS: string = `DELETE FROM assessment_details`;

  public static DELETE_ASSESSMENT_DETAILS_BY_UUID: string = `DELETE FROM assessment_details WHERE uuid=?`;

  public static DELETE_ASSESSMENT_DETAILS_BY_ASMT_ID: string = `DELETE FROM assessment_details WHERE assessment_id=?`;

  public static GET_ASSESSMENT_DETAILS_AFTER_EDIT: string = `SELECT * FROM assessment_details 
        WHERE assessment_id=? AND section_type_lookup_code=? AND rec_type_lookup_code=?`;

  public static GET_ASSESSMENT_DETAILS_BY_UUID: string = `SELECT * FROM assessment_details WHERE uuid=?`;

  public static UPDATE_ASSESSMENT_DETAILS_AFTER_EDIT: string = `UPDATE assessment_details SET data_json=?, updated_date=?
        WHERE assessment_id=? AND section_type_lookup_code=? AND rec_type_lookup_code=?`;

  public static UPDATE_ASSESSMENT_DETAILS_BY_UUID: string = `UPDATE assessment_details 
        SET data_json=?, updated_date=? WHERE uuid=?`;

  public static UPDATE_ASSESSMENT_DETAILS_BY_ASMT_ID: string = `UPDATE assessment_details 
        SET assessment_id=? WHERE assessment_id=?`;

  public static UPDATE_ASSESSMENT_STATUS: string = `UPDATE assessment_details 
        SET status_lookup_code=? WHERE section_type_lookup_code=? and assessment_id=?`;

  public static GET_ASSESSMENT_STATUS_BY_SECTION: string = `select * from assessment_details 
        WHERE section_type_lookup_code=? and assessment_id=?`;

  public static INSERT_ASSESSMENT_DETAILS_AFTER_EDIT: string = `INSERT INTO assessment_details
        (uuid, pat_chart_id, assessment_id, section_type_lookup_code, rec_type_lookup_code, 
        data_json, created_date, updated_date, created_by, updated_by, active_flag)
        VALUES(?, ?, ?, ?, ?,
        ?, ?, ?, ?, ?, ?)`;

  public static SELECT_ASSESSMENT_DETAILS: string = `SELECT * FROM assessment_details WHERE assessment_id = ?`;

  public static SELECT_ASSESSMENT_SECTION_STATUS_VALUE: string = `
        SELECT ad.assessment_id, ad.section_type_lookup_code, ad.status_lookup_code, asmt_status_lookup_code, asmt_type_lookup_code, performed_by_id
        FROM assessment_details ad
        LEFT JOIN assessments asmt
        ON asmt.id = ad.assessment_id
        WHERE ad.assessment_id = ?
        GROUP BY ad.section_type_lookup_code
    `;

  public static SELECT_ASSESSMENT_DETAILS_SECTION_STATUS_VALUE: string = `
        SELECT asmt.asmt_status_lookup_code, asmt.asmt_type_lookup_code, asmt.performed_by_id, ad.assessment_id, ad.section_type_lookup_code, ad.status_lookup_code
        FROM assessments asmt
        LEFT JOIN assessment_details ad
        ON ad.assessment_id = asmt.id 
        WHERE asmt.id = ?
    `;

  public static SELECT_ASSESSMENT_DETAILS_BY_ASMT_ID_AND_SECTION: string = `
        SELECT * FROM assessment_details WHERE assessment_id = ? AND section_type_lookup_code = ?
    `;

  // Rules Template Queries
  public static INSERT_RULES_TEMPLATE: string = `
        INSERT INTO rules_template
        (tenant_id, tmpl_path, tmpl_json, asmt_type_lookup_code, role_lookup_code)
        VALUES(?, ?, ?, ?, ?)
    `;

  public static DELETE_RULES_TEMPLATE: string = `
        DELETE FROM rules_template;
    `;

  public static SELECT_RULE_TEMPLATE_BY_LOOKUP_CODE: string = `
        SELECT tmpl_json
        FROM rules_template
        WHERE INSTR(asmt_type_lookup_code, ?) > 0 AND INSTR(role_lookup_code, ?) > 0;
    `;

  // Assessment template Config Queries
  public static INSERT_ASSESSMENT_TEMPLATE_CONFIG: string = `
        INSERT INTO assessment_template_config
        (tenant_id, tmpl_version, tmpl_path, tmpl_json, asmt_type_lookup_code)
        VALUES(?, ?, ?, ?, ?)
    `;

  public static DELETE_ASSESSMENT_TEMPLATE_CONFIG: string = `
        DELETE FROM assessment_template_config;
    `;

  public static SELECT_ASMT_TEMPLATE_CONFIG_BY_ASMT_TYPE_LOOKUP_CODE: string = `
        SELECT tmpl_json
        FROM assessment_template_config
        WHERE asmt_type_lookup_code = ?;
    `;

  // Assessment section template config
  public static INSERT_ASSESSMENT_SECTION_TEMPLATE_CONFIG: string = `
        INSERT INTO assessment_section_template_config
        (tenant_id, tmpl_version, tmpl_path, tmpl_json, asmt_type_lookup_code, section_type_lookup_code)
        VALUES(?, ?, ?, ?, ?, ?)
    `;

  public static DELETE_ASSESSMENT_SECTION_TEMPLATE_CONFIG: string = `
        DELETE FROM assessment_section_template_config;
    `;

  // Assessment ENUMS
  public static INSERT_ASSESSMENT_SECTION_TYPE_ENUM: string = `
        INSERT OR REPLACE INTO assessment_section_type_enum
            (section_type, section_type_lookup_code, section_type_lookup_value)
        VALUES
            ('GASTRO', 'CL001.9', 'gastrointestinal'),
            ('CARDIO', 'CL001.8', 'cardiovascular'),
            ('RESPIRATORY', 'CL001.7', 'respiratory'),
            ('GENITO', 'CL001.10', 'genitourinary'),
            ('SKIN', 'CL001.12', 'skin'),
            ('PAIN', 'CL001.6', 'pain'),
            ('NUTRITION', 'CL001.11', 'nutritionalMetabolic'),
            ('NEUROLOGICAL', 'CL001.5', 'neurological'),
            ('MUSCULOSKELETAL', 'CL001.13', 'musculoskeletal'),
            ('ADLSFUNCNEEDS', 'CL001.27', 'adlsFunctionalNeeds'),
            ('HOSPICEAIDE', 'CL001.21', 'hospiceAide'),
            ('HOMEMAKER', 'CL001.22', 'homemaker'),
            ('SOCIAL_WORK', 'CL001.18', 'socialWork'),
            ('SUMMARYCOC', 'CL001.23', 'summary'),
            ('SAFETY', 'CL001.15', 'precautionsSafetyTeachings'),
            ('LEVEL_OF_CARE', 'CL001.2', 'levelOfCare'),
            ('PREFERENCES', 'CL001.26', 'preferences'),
            ('VITALS', 'CL001.4', 'vitals'),
            ('FACETOFACE', 'CL001.17', 'faceToFace'),
            ('FACETOFACEMD', 'CL001.28', 'faceToFaceMD'),
            ('VOLUNTEER', 'CL001.24', 'volunteer'),
            ('SUPERVISORY', 'CL001.16', 'supervisoryVisit'),
            ('BEREAVEMENT', 'CL001.20', 'bereavement'),
            ('SPIRTUALCARE', 'CL001.19', 'spiritualCare'),
            ('hospiceAideHACarePlan', 'CL001.30', 'hospiceAideHACarePlan'),
            ('militaryHistory', 'CL001.31', 'militaryHistory'),
            ('BILLING', 'CL001.29', 'billing')
		`;

  public static SELECT_LOGEDIN_USER: string = `SELECT qbos_user_id, user_role FROM user_role`;

  public static PERMISSION_DICTIONARY_INSERT: string = `
        INSERT INTO permission_dictionary
        (group_id, workgroup, access_lookup_code, access_lookup_value)
        VALUES(?, ?, ?, ?)
    `;

  public static DELETE_PERMISSION_DICTIONARY: string = `DELETE FROM permission_dictionary`;

  public static FETCH_PERMISSION_BY_ROLE: string = `
        SELECT pd.workgroup, pd.access_lookup_code, pd.access_lookup_value
        FROM permission_dictionary pd
        LEFT JOIN team_role tr
        ON tr.work_group = pd.workgroup
        WHERE tr.role_lookup_code = ?
        AND access_lookup_code like "%/%"
        AND access_lookup_value > 0;
    `;

  // Assessment Validation Queries
  public static ASSESSMENT_VALIDATION_INSERT: string = `
        INSERT INTO assessment_validation
        (pat_chart_id, admit_visit, ica_visit, previouse_asmt, open_asmt, patient_timezone)
        VALUES(?, ?, ?, ?, ?, ?)
    `;

  public static DELETE_ASSESSMENT_VALIDATION: string = `DELETE FROM assessment_validation`;

  public static FETCH_ASMT_VALIDATION_BY_PATIENT: string = `SELECT * FROM assessment_validation WHERE pat_chart_id = ?`;

  public static FETCH_ROLE_BY_LOOKUP_CODE: string = `SELECT team_role FROM team_role WHERE role_lookup_code = ?`;

  public static IS_ASMT_EXISTS_FOR_PATIENT: string = `
        SELECT COUNT(*) as count
        FROM assessments
        WHERE pat_chart_id = ?;
    `;

  public static IS_ASMT_CREATED_IN_OFFLINE_MODE: string = `
        SELECT COUNT(*) as count
        FROM assessments
        WHERE pat_chart_id = ?
        AND offline_insert = 1;
    `;

  public static SELECT_PATIENT_DARE_STATUS: string = `
        SELECT dareStatus FROM patient_data WHERE chartId = ?
    `;
}



// WEBPACK FOOTER //
// ./src/providers/offline-database/db-queries.ts